import * as React from 'react';

const ErrorPage: React.FC = (props) => {
  const { children } = props;

  return (
    <div className="ErrorPage mt-30 mb-30">
      <div className="row">
        <div className="col-lg-8 offset-lg-2">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
